/*
 * @Author: xuejian3721
 * @Date: 2024-01-30 10:10:26
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-02-01 09:19:10
 */
/**
 * 配置
 * sdkUrl 引入js
 * CLK特指点击事件
 * OTHER 其他事件埋点
 * */

export const sdkUrl =
  'https://o.alicdn.com/QTSDK/quicktracking-sdk/qt_web.cjs.js';
export const aliBuriedConfig = {
  DEBUG: process.env.NODE_ENV !== 'production', //开启调试模式  开启后，控制台将输出SDK 埋点日志
  'aplus-waiting': 'MAN',
  appVersion: 'v1.0.0',
  appKey:
    process.env.NODE_ENV === 'production'
      ? 'tzqatq5hmb3bmmccz2ju15do'
      : 'kvd2200fisflpqydd2waiozl', // 集成应用的appKey
  'aplus-rhost-v': 'https://quickaplus-he-api-cn-shanghai.aliyuncs.com', //如果是私有云部署还需要在上面那段JS后面紧接着添加日志域名埋点  //通常私有云日志服务端域名类似于：quickaplus-web-api.xxx.com.cn, 具体域名要找交付同学要
  'aplus-autotrack-enabled': false,
  _hold: 'BLOCK', // 发送Hold信号. 在 SDK整个生命周期内, _hold可设置多次，但BLOCK与START需成对出现，否则会影响日志发送
  'aplus-exposure-event-can-repeat': false, // SDK在单页应用中，当存在页面离开后又返回的场景时，会再次重复上报曝光事件，如果需要关闭此默认行为，可以通过设置
  'aplus-disable-apv': false // 页面自动上报默认是开启的， 如果需要关闭自动页面上报设置true，
};
